<template>
    <button type="button" @click="itemClick()"
    class="inline-flex items-center leading-none transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-brand-400"
    :class="[buttonToneClass, `rounded-${rounded} text-${size} font-${weight} px-${px} py-${py}`]"
  >  <font-awesome-icon v-if="icon" :class="[iconClass ? iconClass : 'h-3 mx-3 w-3 mr-2', iconToneClass]" :icon="icon" />{{label}}
    </button>
</template>
<script setup>
import { computed } from 'vue';

const emit = defineEmits(["click"]);

const itemClick = () =>{
    emit("click",true)
}

const props = defineProps({ 
    label:{
      type: String,
      default: 'No content'
    },
    variant:{
      type: String,
      default: 'primary' //secondary - light
    },
    icon:{
      type: [Object,String],
      default: null
    },
    iconClass:{
      type: String,
      default: 'sky'
    },
    color:{
      type: String,
      default: 'sky'
    },
    rounded:{
      type: String,
      default: 'md'
    }, 
    weight:{
      type: String,
      default: 'light'
    }, 
    size:{
      type: String,
      default: 'xs'
    }, 
    py:{
      type: String,
      default: '1.5'
    }, 
    px:{
      type: String,
      default: '3'
    }
});

const toneMap = {
  brand: {
    primary: 'text-white shadow-sm border border-transparent bg-brand-800 hover:bg-brand-700 active:bg-brand-900',
    secondary: 'text-brand-900 shadow-sm border border-transparent bg-brand-100 hover:bg-brand-200 active:bg-brand-300',
    light: 'text-brand-800 shadow-sm border border-brand-300 bg-white hover:bg-brand-50 active:bg-brand-100',
    icon: 'text-brand-800 fill-brand-800'
  },
  accent: {
    primary: 'text-white shadow-sm border border-transparent bg-accent-500 hover:bg-accent-600 active:bg-accent-700',
    secondary: 'text-accent-800 shadow-sm border border-transparent bg-accent-100 hover:bg-accent-200 active:bg-accent-300',
    light: 'text-accent-700 shadow-sm border border-accent-300 bg-white hover:bg-accent-50 active:bg-accent-100',
    icon: 'text-accent-700 fill-accent-700'
  },
  support: {
    primary: 'text-white shadow-sm border border-transparent bg-support-600 hover:bg-support-700 active:bg-support-800',
    secondary: 'text-support-800 shadow-sm border border-transparent bg-support-100 hover:bg-support-200 active:bg-support-300',
    light: 'text-support-700 shadow-sm border border-support-300 bg-white hover:bg-support-50 active:bg-support-100',
    icon: 'text-support-700 fill-support-700'
  },
  neutral: {
    primary: 'text-white shadow-sm border border-transparent bg-neutral-600 hover:bg-neutral-700 active:bg-neutral-800',
    secondary: 'text-neutral-800 shadow-sm border border-transparent bg-neutral-200 hover:bg-neutral-300 active:bg-neutral-400',
    light: 'text-neutral-700 shadow-sm border border-neutral-300 bg-white hover:bg-neutral-50 active:bg-neutral-100',
    icon: 'text-neutral-700 fill-neutral-700'
  },
  danger: {
    primary: 'text-white shadow-sm border border-transparent bg-red-600 hover:bg-red-700 active:bg-red-800',
    secondary: 'text-red-800 shadow-sm border border-transparent bg-red-100 hover:bg-red-200 active:bg-red-300',
    light: 'text-red-700 shadow-sm border border-red-300 bg-white hover:bg-red-50 active:bg-red-100',
    icon: 'text-red-700 fill-red-700'
  }
}

const colorFamilyMap = {
  brand: 'brand',
  accent: 'accent',
  support: 'support',
  neutral: 'neutral',
  sky: 'brand',
  blue: 'brand',
  purple: 'brand',
  indigo: 'brand',
  yellow: 'accent',
  amber: 'accent',
  orange: 'accent',
  teal: 'support',
  emerald: 'support',
  green: 'support',
  slate: 'neutral',
  gray: 'neutral',
  red: 'danger',
  rose: 'danger',
  white: 'neutral'
}

const colorFamily = computed(() => colorFamilyMap[props.color] || 'brand')
const variantKey = computed(() => (['primary', 'secondary', 'light'].includes(props.variant) ? props.variant : 'primary'))

const buttonToneClass = computed(() => {
  if (props.color === 'white') {
    return 'text-neutral-600 shadow-sm border border-transparent bg-white hover:bg-neutral-100 active:bg-neutral-200'
  }
  return toneMap[colorFamily.value]?.[variantKey.value] || toneMap.brand.primary
})

const iconToneClass = computed(() => {
  if (props.iconClass && props.iconClass.length > 0) {
    return ''
  }
  if (variantKey.value === 'primary') {
    return 'text-white fill-white'
  }
  return toneMap[colorFamily.value]?.icon || 'text-brand-800 fill-brand-800'
})

</script>
 
 
